var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 45,
    viewBox: "0 0 43 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 45,
    rx: 7,
    fill: "#00C820"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8406 26.5313L22.5781 14.6313C22.2843 14.2906 21.7187 14.2906 21.4218 14.6313L11.1593 26.5313C10.7781 26.975 11.1218 27.625 11.7375 27.625H32.2625C32.8781 27.625 33.2218 26.975 32.8406 26.5313Z",
    fill: "white",
    fillOpacity: 0.46
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionIn);
export default __webpack_public_path__ + "static/media/transactionIn.41efd76635d6aa177f13b0226dad84fe.svg";
export { ForwardRef as ReactComponent };